/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { Form, Button, Spinner, Modal } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import handleResponseError from '../../../../../utils/handleResponseError';
import PaymentMethodHttpService from '../../../../../services/http/payment-method.http';

interface filters {
    name: string;
    paymentMethodOrigin: string;
    reference: string;
    maxInstallments: number;
    defaultInstallment: number;
}

interface PaymentMethodsModalProps {
    isEdit: boolean;
    selectedMethod: any;
    update: () => void;
    isOpen: (value: boolean) => void;
    onHide: () => void;
    show: boolean;
}


const PaymentMethodsModal = ({
    isEdit,
    selectedMethod,
    update,
    isOpen,
    onHide,
    show,
}: PaymentMethodsModalProps) => {
    const [loading, setLoading] = useState(false);
    const {
        control: formControl,
        watch,
        reset,
        setValue,
    } = useForm<filters>({
        shouldUnregister: false,
        defaultValues: {
            name: "",
            paymentMethodOrigin: "",
            reference: "",
            maxInstallments: 1,
            defaultInstallment: 1
        },
    });

    const fieldsData = watch();

    const createPaymentMethod = async () => {
        setLoading(true);
        try {
            const payload = {
                name: fieldsData.name,
                reference: fieldsData.reference,
                maxInstallments: Number(fieldsData.maxInstallments),
                defaultInstallment: Number(fieldsData.maxInstallments)
            }
            const response = await PaymentMethodHttpService.createPaymentMethod(payload);
            if (response) {
                update();
                toast.success('Taxa salva com sucesso!');
            }
        } catch (err: any) {
            handleResponseError(err, 'Ocorreu um erro ao salvar taxa.');
        } finally {
            setLoading(false);
        }
    };


    const editMethod = async () => {
        setLoading(true);
        try {
            const payload = {
                id: selectedMethod.id,
                name: fieldsData.name,
                reference: fieldsData.reference,
                maxInstallments: Number(fieldsData.maxInstallments),
                defaultInstallment: Number(fieldsData.defaultInstallment)
            }
            const response = await PaymentMethodHttpService.editPaymentMethod(payload);
            if (response) {
                update();
                toast.success('Taxa salva com sucesso!');
            }
        } catch (err: any) {
            handleResponseError(err, 'Ocorreu um erro ao salvar taxa.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (selectedMethod) {
            setValue('reference', selectedMethod.reference || '');
            setValue('name', selectedMethod.name || '');
            setValue('maxInstallments', selectedMethod.maxInstallments || 1);
            setValue('defaultInstallment', selectedMethod.defaultInstallment || 1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedMethod, show]);

    useEffect(() => {
        if (!selectedMethod) {
            reset();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);

    return (
        <Modal
            className="modal-dialog-scrollable"
            show={show}
            onHide={onHide}
            size="lg"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="ml-3 mr-3" id="contained-modal-title-vcenter">
                    {isEdit ? 'Editar método de pagamento' : 'Criar método de pagamento'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="w-100">
                
                <Form.Group controlId="reference">
                    <Form.Label>Referencia (em maiúsculo e inglês):</Form.Label>
                    <Controller
                        render={({ onChange, value }) => (
                            <Form.Control
                                type="text"
                                value={value}
                                onChange={onChange}
                            />
                        )}
                        rules={{ required: 'Campo obrigatório' }}
                        control={formControl}
                        name="reference"
                    />
                </Form.Group>

                <Form.Group controlId="paymentMethodOrigin">
                    <Form.Label>Nome do método de pagamento:</Form.Label>
                    <Controller
                        render={({ onChange, value }) => (
                            <Form.Control
                                type="text"
                                value={value}
                                onChange={onChange}
                            />
                        )}
                        rules={{ required: 'Campo obrigatório' }}
                        control={formControl}
                        name="name"
                    />
                </Form.Group>

                <Form.Group controlId="defaultInstallment">
                    <Form.Label>Quantidade de parcelas por padrão:</Form.Label>
                    <Controller
                        render={({ onChange, value }) => (
                            <Form.Control
                                type="number"
                                min={1}
                                value={value}
                                onChange={onChange}
                            />
                        )}
                        rules={{ required: 'Campo obrigatório' }}
                        control={formControl}
                        name="defaultInstallment"
                        defaultValue={1}
                    />
                </Form.Group>
                <Form.Group controlId="maxInstallments">
                    <Form.Label>Quantidade máxima de parcelas</Form.Label>
                    <Controller
                        render={({ onChange, value }) => (
                            <Form.Control
                                type="number"
                                min={1}
                                value={value}
                                onChange={onChange}
                            />
                        )}
                        rules={{ required: 'Campo obrigatório' }}
                        control={formControl}
                        name="maxInstallments"
                        defaultValue={0}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer className="ml-3 mr-3 mb-2">
                <Button
                    variant="outline-primary"
                    style={{ width: '150px' }}
                    onClick={() => {
                        reset();
                        isOpen(false);
                    }}
                >
                    Cancelar
                </Button>
                <Button
                    style={{ width: '150px' }}
                    onClick={isEdit ? editMethod : createPaymentMethod}
                >
                    {loading ? <Spinner animation="border" /> : 'Salvar método'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PaymentMethodsModal;
